export const FORMAT_CURRENCY_CLICKED = "FORMAT_CURRENCY_CLICKED";
export const FORMAT_INCREASE_DECIMAL_CLICKED =
  "FORMAT_INCREASE_DECIMAL_CLICKED";
export const FORMAT_DECRESE_DECIMAL_CLICKED = "FORMAT_DECRESE_DECIMAL_CLICKED";
export const FORMAT_PERCENTAGE_CLICKED = "FORMAT_PERCENTAGE_CLICKED";
export const FORMAT_1000_SEPARATED_CLICKED = "FORMAT_1000_SEPARATED_CLICKED";
export const GET_SELECTED_CURRENCY = "GET_SELECTED_CURRENCY";
